module.exports = __webpack_public_path__ + "img/img14.59c82e34.png";